module.exports = __webpack_public_path__ + "img/ai_active.3555682a.png";